import config from './configs';
import {
  $gamudaPrimaryColor,
  $spsPrimaryColor,
  $asiagreenPrimaryColor,
  $ijmPrimaryColor,
  $aspenPrimaryColor,
  $lbsPrimaryColor,
  $color42,
} from './styles/Variables';

import gamudaBackground from './images/gamuda-background.jpg';
import asiagreenBackground from './images/asiagreen-background.jpeg';
import ijmBackground from './images/ijm-background.png';
import aspenBackground from './images/aspen-background.png';
import lbsBackground from './images/lbs-background.png';

export interface ThemeData {
  pageTitle?: string;
  primaryColor?: string;
  backgroundImage?: string;
  registrationBackgroundImage?: string;
  companyLogo?: string;
  companyLogoMinHeight?: string;
  companyLogoMinWidth?: string;
  companyLogoMarginLeft?: string;
  hyperlinkColor?: string;
  buttonColor?: string;
  buttonTextColor?: string;
}

const getCompanyThemeName = (): string => {
  const themeName = config.companyThemeName;
  return themeName;
};

export const getCompanyThemeData = (): ThemeData => {
  switch (getCompanyThemeName()) {
    case 'env':
      return {
        pageTitle: config.companyFullName,
        primaryColor: `#${config.companyPrimaryColorCode}`,
        backgroundImage: config.companyBackgroundImageUrl,
        registrationBackgroundImage: config.companyRegistrationBackgroundImageUrl,
        companyLogo: config.companyLogoUrl,
        companyLogoMinWidth: config.companyLogoMinWidth,
        companyLogoMinHeight: config.companyLogoMinHeight,
        buttonTextColor: `#${config.buttonTextColorCode}`,
        hyperlinkColor: `#${config.hyperlinkColorCode}`,
      };
    case 'gamuda':
      return {
        pageTitle: 'Gamuda Land',
        primaryColor: $gamudaPrimaryColor,
        backgroundImage: gamudaBackground,
        companyLogo: config.companyLogoUrl,
        companyLogoMinWidth: '23.5vh',
        companyLogoMinHeight: '8.5vh',
        companyLogoMarginLeft: '-3.5vh',
        buttonColor: '#000',
      };
    case 'sps':
      return {
        pageTitle: 'S P Setia',
        primaryColor: $spsPrimaryColor,
        backgroundImage: config.companyBackgroundImageUrl,
        companyLogo: config.companyLogoUrl,
        companyLogoMinHeight: '9vh',
        hyperlinkColor: $color42,
        buttonColor: 'primary',
      };
    case 'asiagreen':
      return {
        pageTitle: 'Asia Green Group',
        primaryColor: $asiagreenPrimaryColor,
        backgroundImage: asiagreenBackground,
        companyLogo: config.companyLogoUrl,
        companyLogoMinHeight: '9vh',
        hyperlinkColor: $color42,
        buttonColor: 'primary',
      };
    case 'ijm':
      return {
        pageTitle: 'IJM Land',
        primaryColor: $ijmPrimaryColor,
        backgroundImage: ijmBackground,
        companyLogo: config.companyLogoUrl,
        companyLogoMinWidth: '22.5vh',
        companyLogoMinHeight: '3.7vh',
        hyperlinkColor: $color42,
        buttonColor: 'primary',
      };
    case 'aspen':
      return {
        pageTitle: 'Aspen Group',
        primaryColor: $aspenPrimaryColor,
        backgroundImage: aspenBackground,
        companyLogo: config.companyLogoUrl,
        companyLogoMinWidth: '12vh',
        companyLogoMinHeight: '12vh',
        hyperlinkColor: $color42,
        buttonColor: '#006E79',
      };
    case 'lbs':
      return {
        pageTitle: 'LBS Bina Group',
        primaryColor: $lbsPrimaryColor,
        backgroundImage: lbsBackground,
        companyLogo: config.companyLogoUrl,
        companyLogoMinWidth: '15.5vh',
        companyLogoMinHeight: '4.7vh',
        hyperlinkColor: $color42,
        buttonColor: 'primary',
      };
    default:
      return {};
  }
};
